import React from 'react';
import { Icon } from './Icon.js';
export const IconCreditCard = ({ ...props }) => {
    return (React.createElement(Icon, { size: "24px", ...props },
        React.createElement("path", { d: "M2 9H22", stroke: "currentColor", strokeWidth: "2", fill: "none" }),
        React.createElement("path", { d: "M7 15H8", stroke: "currentColor", strokeWidth: "2", strokeLinecap: "square", "data-color": "color-2", fill: "none" }),
        React.createElement("path", { d: "M2 4L2 20L22 20L22 4L2 4Z", stroke: "currentColor", strokeWidth: "2", strokeMiterlimit: "10", strokeLinecap: "square", fill: "none" })));
};
//# sourceMappingURL=IconCreditCard.js.map